import { Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker2";
import { Controller } from "react-hook-form";
import SearchableSelect from "../../Components/SearchableSelect";
import { getUserListASync } from "../../store/api/Users";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
import { monitorRemoveMonitorWorkItem } from "../store/api/FlowAPI";

const WorkItemControl = ({ workItemData, setWorkItemData, control, register }) => {
    const dispatch = useDispatch();

    const handleSupervisorSearch = async (qry) => {
        const result = await getUserListASync(qry);
        if (Array.isArray(result)) {
            return result.map(r => ({
                value: r.ID,
                label: r.Name
            }));
        }
        return [];
    }
    const handleApproverSearch = async (qry) => {
        const result = await getUserListASync(qry);
        if (Array.isArray(result)) {
            return result.map(r => ({
                value: r.ID,
                label: r.Name
            }));
        }
        return [];
    }
    const handleResponsibleSearch = async (qry) => {
        const result = await getUserListASync(qry);
        if (Array.isArray(result)) {
            return result.map(r => ({
                value: r.ID,
                label: r.Name
            }));
        }
        return [];
    }
    const handleUserSelect = (name, opt) => {
        setWorkItemData(prev => ({
            ...prev,
            [`${name}ID`]: opt.value,
            [`${name}Name`]: opt.label
        }))
    }
    const monitorRemoveMonitor = async () => {
        const result = await monitorRemoveMonitorWorkItem(workItemData?.ID)
        if (result.Message) {
            setErrorDialog(dispatch, result.Error, "درج در لیست پیگیری");
        }
        else if (result.Data) {
            setErrorDialog(dispatch, "success", "درج در لیست پیگیری");
        }
    }
    return (
        <Row className="rowBorder mt-3">
            <div className="rowTitle">
                کنترل کار
            </div>
            <Col md={2} className="form-group">
                <label>مدت لازم:</label>
                <Form.Control type="number" name="EstimatedDurationMinutes" ref={register({})} />
            </Col>
            <Col md={2} className="form-group">
                <label>زمان یادآوری:</label>
                <Controller
                    name="AlarmDate"
                    control={control}
                    render={({ onChange, value }) => (
                        <DatePicker
                            className="form-control"
                            isGregorian={false}
                            timePicker={false}
                            value={value}
                            onChange={onChange}
                        />
                    )}
                />
            </Col>
            <Col md={2} className="form-group">
                <label>زمان آغاز:</label>
                <Controller
                    name="StartDate"
                    control={control}
                    render={({ onChange, value }) => (
                        <DatePicker
                            className="form-control"
                            isGregorian={false}
                            timePicker={false}
                            value={value}
                            onChange={onChange}
                        />
                    )}
                />
            </Col>
            <Col md={2} className="form-group">
                <label>زمان پایان:</label>
                <Controller
                    name="CompletedDate"
                    control={control}
                    render={({ onChange, value }) => (
                        <DatePicker
                            className="form-control"
                            isGregorian={false}
                            timePicker={false}
                            value={value}
                            onChange={onChange}
                        />
                    )}
                />
            </Col>
            <Row>
                <Col md={2} className="form-group">
                    <label>مسئول:</label>
                    <SearchableSelect
                        value={workItemData?.ResponsibleUserID ?? 0}
                        defaultLabel={workItemData?.ResponsibleUserName ?? ""}
                        name="ResponsibleUserID"
                        control={control}
                        placeholder="جستجوی کاربر ..."
                        loadOptions={handleResponsibleSearch}
                        onChange={val => handleUserSelect("ResponsibleUser", val)}
                    />
                </Col>
                <Col md={2} className="form-group">
                    <label>ناظر:</label>
                    <SearchableSelect
                        value={workItemData?.SupervisorUserID ?? 0}
                        defaultLabel={workItemData?.SupervisorUserName ?? ""}
                        name="SupervisorUserID"
                        control={control}
                        placeholder="جستجوی کاربر ..."

                        loadOptions={handleSupervisorSearch}
                        onChange={val => handleUserSelect("SupervisorUser", val)}
                    />
                </Col>
                <Col md={2} className="form-group">
                    <label>تایید کننده:</label>
                    <SearchableSelect
                        value={workItemData?.ApproverUserID ?? 0}
                        defaultLabel={workItemData?.ApproverUserName ?? ""}
                        name="ApproverUserID"
                        control={control}
                        placeholder="جستجوی کاربر ..."
                        loadOptions={handleApproverSearch}
                        onChange={val => handleUserSelect("ApproverUser", val)}
                    />

                </Col>
                {workItemData.ShowMonitor &&
                    <Col md={2}
                        style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                        <div className="mt-4">
                            <input 
                            type="checkbox" 
                            className="form-check-input" 
                            id="chkMonitor" 
                            name="Monitor" 
                            ref={register({})} 
                            onChange={monitorRemoveMonitor} />&nbsp;
                            <label htmlFor="chkMonitor" >درج در لیست پیگیری</label>
                        </div>
                    </Col>
                }
            </Row>
        </Row>
    )
}
export default WorkItemControl;